import { render, staticRenderFns } from "./ParcelThumbnail.vue?vue&type=template&id=df6db356&scoped=true"
import script from "./ParcelThumbnail.vue?vue&type=script&lang=ts"
export * from "./ParcelThumbnail.vue?vue&type=script&lang=ts"
import style0 from "./ParcelThumbnail.vue?vue&type=style&index=0&id=df6db356&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df6db356",
  null
  
)

export default component.exports